import { render } from "./TabsPage.vue?vue&type=template&id=5fddedc4"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=5fddedc4&lang=scss"

import exportComponent from "/Users/damiandudek/Desktop/PRACA/git/114.TGA-mobile-git/tga-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__